const apiConfig = {
    dev: 'https://boss-reads.qinxuecloud.com/api',
    // dev: 'http://api-sn.devdev.com/api',
    // dev: 'http://192.168.2.211/api',
    // dev: 'http://boss.htzygz.com/api',
    test: 'http://oa.test.api.qinxue100.com:8080/api',
    prod: 'http://boss.htzygz.com/api'
}
let HOST = process.env.HOST, url = '/api'

if (!['dev', 'test', 'prod'].includes(HOST)) {
    url = HOST
} else {
    url = apiConfig[HOST]
}
export default url



// WEBPACK FOOTER //
// ./src/service/hostconfig.js